import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
class Videos extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
  window.menu_selection('/pro_bono_begal_help');
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="Insights"/>
          <div className="container-xxl py-5">
              <div className="container inner_con">

                  <div className="row g-4 mb-5">
                      <h2 className="text-start mb-2 wow fadeInUp title_view" data-wow-delay="0.1s">Videos</h2>
                     <div class="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                         <a class="cat-item rounded p-4">
                         <div class="d-flex align-items-center mb-3">
                             <iframe width="100%" height="auto" src="https://www.youtube.com/embed/wDchsz8nmbo?si=1dbWOzUPaimMWGQ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                         </div>
                          <small><i>Title</i></small>
                          <p>Expertise in Banking Law, DRT, Intellectual Property Rights, and Consumer Protection Law</p>
                         </a>
                     </div>
                  </div>
                </div>
            </div>
          <Footer />
        </div>
    );
  }
}

export default Videos;
